/**
 * Utility functions for working with IDs.
 */
import { assert } from "./assert";

export const signInActivityWorkflowId = ({
  userId,
  executionId,
}: {
  userId: string;
  executionId: string;
}) => `signIn_user_${userId}_execution_${executionId}`;

/**
 * Extract the executionId from a workflowId.
 *
 * @throws if the workflowId is not valid.
 */
export const executionIdFromWorkflowId = (workflowId: string) => {
  const executionId = workflowId.match(/execution_([0-9a-f-]+)/)?.[1];
  assert(executionId, `Invalid workflowId: ${workflowId}`);
  return executionId;
};

/**
 * Given a string that may be a workflowId or an executionId, return the
 * executionId. Only intended for backwards compatibility.
 */
export const executionIdFromExecutionOrWorkflowId = (
  id: string | null | undefined,
) => {
  if (!id) {
    return null;
  }

  try {
    return executionIdFromWorkflowId(id);
  } catch {
    return id;
  }
};
